import state from './moduleRawMaterialState.js'
import mutations from './moduleRawMaterialMutations.js'
import actions from './moduleRawMaterialActions.js'
import getters from './moduleRawMaterialGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

